// extracted by mini-css-extract-plugin
export var close = "book-preview-modal-module--close--H2hTa";
export var collection = "book-preview-modal-module--collection--UppXm";
export var content = "book-preview-modal-module--content--2AK9N";
export var description = "book-preview-modal-module--description--tUWCC";
export var details = "book-preview-modal-module--details--hbHzm";
export var overlay = "book-preview-modal-module--overlay--F5KKk";
export var panel = "book-preview-modal-module--panel--m4Nui";
export var period = "book-preview-modal-module--period--LNzie";
export var visual = "book-preview-modal-module--visual--6GMNp";